module.exports = __webpack_public_path__ + "static/media/logotype.53b478ed.mp4";